/* globals Forms */

import ApplicationController from './application_controller'
import { Modal } from 'bootstrap'

class ModalController extends ApplicationController {
  connect () {
    this.modal = new Modal(this.element)
  }

  open () {
    const hasDatevExchangeRetrieveModal = !!this.element.querySelector('.datev-exchange-retrieve-modal-host')
    this.element.classList.toggle('modal--datev-exchange-retrieve', hasDatevExchangeRetrieveModal)

    if (!this.modal.isOpened) {
      this.modal.show()
      Forms.initForm()
    }
  }

  close (event) {
    if (event.detail.success) {
      this.modal.hide()
      this.element.classList.remove('modal--datev-exchange-retrieve')
    }
  }
}

export default ModalController
